import { Container } from '@cgs/wge';
import { T_BaseSlotSoundController, T_ISlotPopupCoordinator } from '../../../../type_definitions';
import { BaseSlotController } from '../../base_slot_controller';
import { BaseSlotSoundController } from '../../base_slot_sound_controller';
import { ISlotPopupView } from '../../base_slot_view';
import { ISlotPopupCoordinator } from '../../slot_popup_coordinator';

export class BaseSlotPopupController<T extends ISlotPopupView> extends BaseSlotController<T> {
  protected readonly _slotPopupCoordinator: ISlotPopupCoordinator;
  protected readonly _slotSoundController: BaseSlotSoundController;
  protected readonly _stopBackgroundSound: boolean;

  constructor(container: Container, popupView: T, stopBackgroundSound: boolean) {
    super(container, popupView);
    this._stopBackgroundSound = stopBackgroundSound;
    this._slotPopupCoordinator = container.resolve<ISlotPopupCoordinator>(T_ISlotPopupCoordinator);
    this._slotSoundController =
      container.resolve<BaseSlotSoundController>(T_BaseSlotSoundController);

    this.view = popupView;
    this.view.shown.listen(() => this.onPopupShown());
    this.view.showing.listen(() => this.onPopupShowing());
    this.view.closed.listen(() => this.onPopupClosed());
  }

  public handleBackKey(): boolean {
    this.view.hide();
    return true;
  }

  protected onPopupShowing(): void {
    this.stopBackgroundSoundIfNeeded();

    this.gameStateMachineNotifier.notifier.notifyListenersEntered('popup');
    this._slotPopupCoordinator.onPopupShown(this.view.popupId!);
  }

  protected stopBackgroundSoundIfNeeded(): void {
    if (this._stopBackgroundSound) {
      this._slotSoundController.stopBackgroundSound();
    }
  }

  protected onPopupClosed(): void {
    this.playBackgroundSoundIfNeeded();

    this.gameStateMachineNotifier.notifier.notifyListenersExited('popup');
    this._slotPopupCoordinator.onPopupHidden(this.view.popupId!);
  }

  protected playBackgroundSoundIfNeeded(): void {
    if (this._stopBackgroundSound) {
      this._slotSoundController.playBackgroundSound();
    }
  }

  protected get slotPopupCoordinator(): ISlotPopupCoordinator {
    return this._slotPopupCoordinator;
  }

  protected get slotSoundController(): BaseSlotSoundController {
    return this._slotSoundController;
  }

  protected onPopupShown(): void {}
}
